export default __webpack_public_path__ + "assets/home-two-four-small.0e10ec92e0e8db4bdb7382e72ae1361f.png";